/*
  BluFood Trust-Leiste (sections/bf-trust-bar.liquid), R22
  Auf Handy/Tablet (unter 990 px) im Modus "wechselnd": eine Aussage nach der anderen.
  - automatischer Wechsel (Einstellung "Wechsel alle"), pausiert bei Hover, im Hintergrund-Tab
    und bei "Bewegung reduzieren"
  - Antippen zeigt die naechste Aussage
  - Theme-Editor: ausgewaehlter Block wird angezeigt
*/
(() => {
  if (customElements.get('bf-trust')) return

  class BfTrust extends HTMLElement {
    connectedCallback () {
      this.items = Array.from(this.querySelectorAll('.bf-trust__item'))
      if (!this.items.length) return
      if (this.index == null) this.index = 0
      this.show(Math.min(this.index, this.items.length - 1))
      if (!this.classList.contains('bf-trust--m-rotate') || this.items.length < 2) return

      if (!this._bound) {
        this._bound = true
        this.mq = window.matchMedia('(max-width: 989px)')
        this.rm = window.matchMedia('(prefers-reduced-motion: reduce)')
        this.addEventListener('mouseenter', () => { this.paused = true })
        this.addEventListener('mouseleave', () => { this.paused = false })
        this.addEventListener('click', () => { if (this.mq.matches) this.show(this.index + 1) })
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.items.indexOf(e.target)
          if (i >= 0) { this.held = true; this.show(i) }
        })
        this.addEventListener('shopify:block:deselect', () => { this.held = false })
      }

      const ms = Math.max(3000, parseInt(this.dataset.interval, 10) || 4000)
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.paused || this.held || document.hidden || !this.mq.matches || this.rm.matches) return
        this.show(this.index + 1)
      }, ms)
    }

    disconnectedCallback () {
      clearInterval(this.timer)
    }

    show (i) {
      const n = this.items.length
      this.index = ((i % n) + n) % n
      this.items.forEach((el, k) => el.classList.toggle('is-active', k === this.index))
    }
  }

  customElements.define('bf-trust', BfTrust)
})()
